// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e8e2842e","667":"c9fcc845"}[chunkId] + ".chunk.js";
};